<template>
  <div class="mislacard" :style="cardStyle(icon)" v-on:click="openUrl(clickurl)">
    <transition name="showtext">
      <div class="cardtext" v-if="textvisible">{{text}}</div>
    </transition>

  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    text: String,
    icon: String,
    clickurl: String
  },
  data: function() {
    return {
      textvisible: false
    }
  },
  methods: {
    cardStyle: function(icon) {
      var img = require(`@/assets/${icon}`);
      img = "url(" + img + ")";
      var res =  {
        "background": img,
      };
      
      return res;
    },
    openUrl: function(clickurl) {
      location.href = clickurl;
    },
    showText: function() {

    }
  },
  created: function () {
    var that = this;
    setTimeout(function() {
      that.textvisible = true;
    }, 500)
     ;
  },
  computed: {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mislacard {
  height: 128px;
  width: 128px;
  background-repeat: no-repeat;
  cursor: pointer;
  float: left;
  margin-right: 5px;
}
.cardtext {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-top: 100px;
  color: white;
  text-shadow: -1px 0 black, 0 1px black,
      1px 0 black, 0 -1px black
}
.showtext-enter-active, .showtext-leave-active {
  transition: opacity 0.5s;
}
.showtext-enter, .showtext-leave-to  {
  opacity: 0;
}
</style>
